var get = require("object-path").get;

/**
 * Create google analytics configuration for Radiant Media Player from the
 * provided media item.
 *
 * @param    {Object}  analyticsService  The analytics service
 * @param    {Object}  media             The media item
 * @returns  {Object}  The google analytics config
 */
module.exports = function(analyticsService, media) {
    var artists           = get(media, "artists", []),
        gaEventParameters = {},
        setup             = {};

    if (analyticsService.isServiceLoaded("googleAnalytics")) {
        gaEventParameters.media_id   = get(media, "id", null);
        gaEventParameters.media_type = get(media, "type", null);

        switch (media.type) {
            case "album_track":
                gaEventParameters.album_title = get(media, "parent.meta.title", null);
                gaEventParameters.track_title = get(media, "meta.title", null);
                break;
            case "audio":
                gaEventParameters.audio_title = get(media, "meta.title", null);
                break;
            case "episode":
                gaEventParameters.series_title  = get(media, "parent.parent.meta.title", null);
                gaEventParameters.season_title  = get(media, "parent.meta.title", null);
                gaEventParameters.episode_title = get(media, "meta.title", null);
                break;
            case "podcast_episode":
                gaEventParameters.podcast_title = get(media, "parent.meta.title", null);
                gaEventParameters.episode_title = get(media, "meta.title", null);
                break;
            case "video":
                gaEventParameters.video_title = get(media, "meta.title", null);
                break;
            default:
                break;
        }
        gaEventParameters.language = get(media, "meta.language", null);
        gaEventParameters.artists  = artists.length ? artists.join(", ") : null;
        gaEventParameters.year     = get(media, "year", null);

        setup.enableGAVideoTracking = true;
        setup.gaEventParameters     = gaEventParameters;
    }

    return setup;
};
